<template>
    <div id="popup">
        <div id="popup__overlay"/>
        <div id="popup__modal">
            <svg-icon
                @click="closePopup"
                icon="close"
                fill="#FF5500"
                height="20px"
                width="20px"
                id="popup__modal__close-icon"
            />
            <img :src="require(`@/assets/popup-heading.png`)" id="popup__modal__image"/>
            <h1>Installeer RTV Parkstad</h1>
            <!-- Android version -->
            <p v-if="android" id="popup__modal__introduction">Installeer deze app op je beginscherm om makkelijker en sneller toegang te krijgen.</p>
            <p v-if="android" id="popup__modal__instruction"><button v-on:click="installPWA()">Installeer</button></p>

            <!-- iOS version -->
            <p v-if="ios" id="popup__modal__introduction">Installeer deze app op je beginscherm om makkelijker en sneller toegang te krijgen.</p>
            <p v-if="ios" id="popup__modal__instruction">Druk op  <svg-icon icon="ios-action2" fill="#1384FF" height="24px" width="26px" id="popup__modal__instruction__action-icon"/>  en kies vervolgens voor 'Zet op beginscherm <svg-icon icon="ios-add" fill="#000000" height="18px" width="20px" id="popup__modal__instruction__add-icon"/>'</p>

            <!-- Other versions -->
            <p v-if="other" id="popup__modal__introduction">Scan de onderstaande QR-code om de app te downloaden.</p>
            <img v-if="other" id="popup__modal__qr-code" src="@/assets/popup-qr-code.svg"/>
        </div>
    </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
    name: "InstallPopup",
    components: {
        SvgIcon
    },
    created() {
        this.didCloseModal = JSON.parse(localStorage.getItem("didCloseModal"));
        if (this.didCloseModal == null) {
            this.didCloseModal = false
        }
        // document.getElementById("player__labels").innerHTML = this.getPWADisplayMode();
    },
    mounted() {
        if(this.isIOS() && !this.didCloseModal && this.getPWADisplayMode() == "browser") {
            // alert("Dit is iOS en nog niet geïnstalleerd");
            this.ios = true;
            this.showPopup();
        } else
        if(this.isAndroid() && !this.didCloseModal && this.getPWADisplayMode() == "browser") {
            this.android = true;
            this.showPopup();
        } else if (this.getPWADisplayMode() == "browser" && !this.didCloseModal) {
            this.other = true;
            this.showPopup();
        }
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event in deferredPrompt to trigger the browser install prompt later.
            this.deferredPrompt = e;
            // Optionally, send analytics event that PWA install promo was shown.
            console.log(`'beforeinstallprompt' event was fired.`);
        });
    },
    methods: {
        showPopup() {
            document.getElementById("popup").style.display = "block";
        },
        closePopup() {
            document.getElementById("popup").style.display = "none";
            this.didCloseModal = true;
            localStorage.setItem("didCloseModal", JSON.stringify(this.didCloseModal));
        },
        getPWADisplayMode() {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            if (document.referrer.startsWith('android-app://')) {
                return 'twa';
            } else if (navigator.standalone || isStandalone) {
                return 'standalone';
            }
            return 'browser';
        },
        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
        },
        isAndroid() {
            let userAgent = navigator.userAgent.toLowerCase()
            if (userAgent.indexOf("android") > -1) {
                return true;
            } else {
                return false;
            }
        },
        async installPWA() {
            this.closePopup();
            // Op localhost werkt dit onderste niet, maar op de server wel
            this.deferredPrompt.prompt();
            this.deferredPrompt = null;
        }
    },
    data() {
        return {
            android: false,
            ios: false,
            other: false,
            didCloseModal: false,
            deferredPrompt: null
        }
    }
};
</script>

<style lang="scss" scoped>
#popup {
    display: none;
    font-family: 'Lato', sans-serif;
    #popup__overlay {
        position: fixed;
        top: 0;
        left: 0;
        background-color: black;
        opacity: 0.7;
        width: 100vw;
        height: 100vh;
        z-index: 9998;
    }
    #popup__modal {
        box-sizing: border-box;
        position: fixed;
        z-index: 9999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background-color: white;
        height: 330px;
        width: 300px;
        padding: 16px;
        border-radius: 5px;

        #popup__modal__close-icon {
            position: absolute;
            right: 16px;
        }

        #popup__modal__image {
            margin: 0px -16px 0px;
            width: 300px;
        }

        h1 {
            text-align: center;
            font-size: 20px;
        }
        #popup__modal__introduction{
            text-align: center;
            font-size: 16px;
        }

        #popup__modal__instruction {
            position: absolute;
            bottom: 0;
            background-color: #F9F9F9;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            width: 300px;
            padding: 16px 16px;
            box-sizing: border-box;
            margin: 0px -16px;
            text-align: center;
            vertical-align: middle;
            line-height: 1.7;
            button {
                font-size: 20px;
                color: white;
                font-weight: bold;
                width: 150px;
                height: 40px;
                border-radius: 999px;
                background-color: #F55000;
                border: none;
            }
            #popup__modal__instruction__action-icon {
                display: inline-block;
            }
            #popup__modal__instruction__add-icon {
                display: inline-block;
            }
        }

        #popup__modal__qr-code {
            position: absolute;
            width: 120px;
            height: 120px;
            margin-top: 5px;
            left: calc(50% - 60px);
        }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #popup {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #popup {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #popup {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #popup {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #popup {
       
    }
}
</style>